import { useEffect } from "react";
import db from "../database";
import { getWorkflowRules } from "../services/generic";
import { Modal } from "antd";
import NotFoundImg from "../assets/images/NotFoundImg.svg";
import { syncSingleProductByValue } from "../services";
import { v4 as uuidv4 } from "uuid";

const BarCodeHandler = (props) => {
  const { setSelectedItems } = props;
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  let dataString = "";
  let timeoutId;

  const handleKeyDown = (e) => {
    const { key } = e;

    // Reset timeout if it exists
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }

    // Set a timeout to clear dataString after inactivity
    timeoutId = setTimeout(() => {
      dataString = "";
      timeoutId = undefined;
    }, 200);

    // Handle Backspace
    if (key === "Backspace") {
      dataString = dataString.slice(0, -1);
    }

    // Append character to dataString if it's alphanumeric or allowed symbols
    if (key.length === 1 && ((key >= "0" && key <= "9") || (key >= "A" && key <= "Z") || (key >= "a" && key <= "z") || key === "-" || key === " ")) {
      dataString += key;
    }

    // Process barcode when Enter (charCode 13) is pressed
    if (key === "Enter" && dataString !== "" && localStorage.getItem("productName") === null) {
      // Log the scanned data for debugging
      console.log("Scanned QR code:", dataString);

      // Process the entire dataString
      console.log("barcode ------------>", dataString.trim());
      barcodeScanFromConfig(dataString.trim());

      // Reset state
      dataString = "";
    }
  };

  const getProduct = async (formula, newData, tillData, config) => {
    let productValue = newData.substr(Number(formula.property["product.value"]?.position - 1), Number(formula.property["product.value"]?.length));
    productValue = config?.delimiter ? productValue.replace(/^0+/, "") : productValue;
    const operators = ["+", "-", "/", "*"];
    const operatorFunctions = {
      "+": (a, b) => a + b,
      "-": (a, b) => a - b,
      "*": (a, b) => a * b,
      "/": (a, b) => a / b,
    };

    await db.products
      .where("value")
      .equalsIgnoreCase(productValue)
      .and((product) => product.isactive === true)
      .and((product) => product.productSegment !== "BG")
      .toArray()
      .then(async (product) => {
        let productList = product;
        if ((!productList || productList.length === 0) && productValue) {
          try {
            console.log("Syncing from getProduct (formula):", productValue);

            const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

            await syncSingleProductByValue(tillData, syncId, tillData?.tillAccess?.cwrTill?.cwrTillID, productValue);

            // 🔁 Re-fetch after sync
            productList = await db.products
              .where("value")
              .equalsIgnoreCase(productValue)
              .and((product) => product.isactive === true)
              .and((product) => product.productSegment !== "BG")
              .toArray();
          } catch (err) {
            console.error("Sync failed in getProduct:", err);
          }
        }

        const productObj = productList[0];

        // ❌ STILL NOT FOUND → show modal (your existing logic)
        if (!productObj) {
          console.log("Product not found for:", productValue);

          Modal.info({
            icon: null,
            okButtonProps: { style: { display: "none" } },
            okText: "Go Back",
            content: (
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "500",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingLeft: 0,
                  fontSize: "1vw",
                }}
              >
                <img src={NotFoundImg} alt="Not Found" style={{ width: "120px", height: "100px", marginBottom: "5px", marginTop: "10px" }} />
                <p style={{ margin: "5px 0", fontSize: "2em", fontWeight: "600", color: "#0F0718" }}>Product Not Found</p>
                <hr style={{ width: "70%", color: "rgba(146,144,152,0.5" }} />
                <p style={{ color: "#0F0718", fontWeight: 400, fontSize: "1.25em", padding: "15px 15px 0 15px" }}>
                  The scanned QR code ({productValue}) is not in the system. Please check the QR code or enter the item manually.
                </p>
              </div>
            ),
            style: {
              textAlign: "center",
              height: "50vh",
              width: "50%",
            },
            bodyStyle: {
              padding: "0",
            },
            closable: false,
            onOk: null,
          });

          setTimeout(() => {
            Modal.destroyAll();
          }, 1500);

          return; // 🔥 IMPORTANT: STOP EXECUTION
        }
        console.log("Product search result:", product, "for value:", productValue);
        const uomData = product[0]?.uomData[0];
        let orderNo = "";
        const currenciesList = tillData.tillAccess.csBunit.currencies;
        let scanFlag = false;
        let cartlineQty;

        if (formula.property["cartline.qty"] !== undefined) {
          if (typeof formula.property["cartline.qty"] === "number") {
            cartlineQty = formula.property["cartline.qty"];
          } else if (typeof formula.property["cartline.qty"] === "string") {
            const foundOperator = operators.find((op) => formula.property["cartline.qty"].includes(op));
            const splitArr = formula.property["cartline.qty"].split(foundOperator);
            let qtyArr = splitArr.map((splitItem) => {
              let value;
              if (splitItem.includes("cartline")) {
                if (splitItem.includes("qty")) {
                  if (typeof formula.property["cartline.qty"] === "number") {
                    value = formula.property["cartline.qty"];
                  } else if (typeof formula.property["cartline.qty"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
                        (uomData && uomData?.decimal === "Y" ? Math.pow(10, uomData?.stdprecision) : 1)
                      ).toFixed(uomData && uomData?.decimal === "Y" ? uomData?.stdprecision : 3)
                    );
                  }
                } else if (splitItem.includes("total")) {
                  if (typeof formula.property["cartline.total"] === "number") {
                    value = formula.property["cartline.total"];
                  } else if (typeof formula.property["cartline.total"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                } else if (splitItem.includes("unitprice")) {
                  if (typeof formula.property["cartline.unitprice"] === "number") {
                    value = formula.property["cartline.unitprice"];
                  } else if (typeof formula.property["cartline.unitprice"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                }
              } else {
                value = product[0].sunitprice;
              }
              return value;
            });
            cartlineQty = operatorFunctions[foundOperator](qtyArr[0], qtyArr[1]);
          } else if (typeof formula.property["cartline.qty"] === "object") {
            cartlineQty = parseFloat(
              (
                Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
                (uomData && uomData?.decimal === "Y" ? Math.pow(10, uomData?.stdprecision) : 1)
              ).toFixed(uomData && uomData?.decimal === "Y" ? uomData?.stdprecision : 3)
            );
          }
        }

        let cartlineUnitprice;
        if (formula.property["cartline.unitprice"] !== undefined) {
          if (typeof formula.property["cartline.unitprice"] === "number") {
            cartlineUnitprice = formula.property["cartline.unitprice"];
          } else if (typeof formula.property["cartline.unitprice"] === "string") {
            const foundOperator = operators.find((op) => formula.property["cartline.unitprice"].includes(op));
            const splitArr = formula.property["cartline.unitprice"].split(foundOperator);
            let unitpriceArr = splitArr.map((splitItem) => {
              let value;
              if (splitItem.includes("cartline")) {
                if (splitItem.includes("qty")) {
                  if (typeof formula.property["cartline.qty"] === "number") {
                    value = formula.property["cartline.qty"];
                  } else if (typeof formula.property["cartline.qty"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
                        (uomData && uomData?.decimal === "Y" ? Math.pow(10, uomData?.stdprecision) : 1)
                      ).toFixed(uomData && uomData?.decimal === "Y" ? uomData?.stdprecision : 3)
                    );
                  }
                } else if (splitItem.includes("total")) {
                  if (typeof formula.property["cartline.total"] === "number") {
                    value = formula.property["cartline.total"];
                  } else if (typeof formula.property["cartline.total"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                } else if (splitItem.includes("unitprice")) {
                  if (typeof formula.property["cartline.unitprice"] === "number") {
                    value = formula.property["cartline.unitprice"];
                  } else if (typeof formula.property["cartline.unitprice"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                }
              } else {
                value = product[0].sunitprice;
              }
              return value;
            });
            cartlineUnitprice = operatorFunctions[foundOperator](unitpriceArr[0], unitpriceArr[1]);
          } else {
            cartlineUnitprice = parseFloat(
              (
                Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
                (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
              ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
            );
          }
        }

        let cartlineTotal;
        if (formula.property["cartline.total"] !== undefined) {
          if (typeof formula.property["cartline.total"] === "number") {
            cartlineTotal = formula.property["cartline.total"];
          } else if (typeof formula.property["cartline.total"] === "string") {
            const foundOperator = operators.find((op) => formula.property["cartline.total"].includes(op));
            const splitArr = formula.property["cartline.total"].split(foundOperator);
            let totalArr = splitArr.map((splitItem) => {
              let value;
              if (splitItem.includes("cartline")) {
                if (splitItem.includes("qty")) {
                  if (typeof formula.property["cartline.qty"] === "number") {
                    value = formula.property["cartline.qty"];
                  } else if (typeof formula.property["cartline.qty"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
                        (uomData && uomData?.decimal === "Y" ? Math.pow(10, uomData?.stdprecision) : 1)
                      ).toFixed(uomData && uomData?.decimal === "Y" ? uomData?.stdprecision : 3)
                    );
                  }
                } else if (splitItem.includes("total")) {
                  if (typeof formula.property["cartline.total"] === "number") {
                    value = formula.property["cartline.total"];
                  } else if (typeof formula.property["cartline.total"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                } else if (splitItem.includes("unitprice")) {
                  if (typeof formula.property["cartline.unitprice"] === "number") {
                    value = formula.property["cartline.unitprice"];
                  } else if (typeof formula.property["cartline.unitprice"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                }
              } else {
                value = product[0]?.sunitprice || 0;
              }
              return value;
            });
            cartlineTotal = operatorFunctions[foundOperator](totalArr[0], totalArr[1]);
          } else {
            cartlineTotal = parseFloat(
              (
                Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
                (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
              ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
            );
          }
        }

        if (formula.property["production.orderNo"] !== undefined) {
          orderNo = newData.substr(Number(formula.property["production.orderNo"]?.position - 1), Number(formula.property["production.orderNo"]?.length));
        }

        if (formula.property["product.unitprice"] !== undefined) {
          if (formula.property["product.unitprice"]?.type === "event") {
            const workflowRules = await db.POSWorkFlowRules.toArray();
            if (workflowRules && workflowRules.length > 0) {
              await Promise.all(
                workflowRules.map(async (res) => {
                  if (res.eventId === "productPriceOnScan") {
                    const serverUrl = process.env.REACT_APP_serverUrl;
                    const CWCoreServicesUrl = process.env.REACT_APP_genericUrl;

                    if (res.apiSource === "APB") {
                      const value = { orderno: orderNo, value: productValue };
                      const newStringifiedFields = JSON.stringify(value).replace(/\\"/g, '\\"');
                      const newStringRequest = JSON.stringify(newStringifiedFields);
                      const apiBuilder = {
                        query: `mutation { executeAPIBuilder(apiBuilderId:"${res.apiEndPoint}", params: ${newStringRequest})} `,
                      };
                      const apiBuilderResponse = await getWorkflowRules(apiBuilder);
                      if (apiBuilderResponse.data.data.executeAPIBuilder.length > 0) {
                        const response = JSON.parse(apiBuilderResponse.data.data.executeAPIBuilder);
                        product[0].mBatchId = response?.length > 0 ? response[0]?.m_batch_id : null;
                        product[0].batchno = response?.length > 0 ? response[0]?.batch_no : null;
                        cartlineUnitprice = parseFloat(response?.length > 0 ? response[0].sale_price.toFixed(currenciesList[0].stdPrecision || 2) : 0);
                      }
                    } else if (res.apiSource === "RES") {
                      console.log("-------------->Retail");
                    } else if (res.apiSource === "CAP") {
                      console.log("-------------->Core");
                    }
                  }
                })
              );
            }
          }
        }

        if (cartlineUnitprice || cartlineTotal) {
          scanFlag = true;
        }
        if (product[0]) {
          const productSegment = localStorage.getItem("productSegment");
          if (productSegment) {
            setSelectedItems((prev) => {
              const newItem = {
                ...product[0],
                weight: cartlineQty,
                rawWeight: cartlineQty,
                sunitprice: cartlineUnitprice || product[0]?.sunitprice,
              };
              console.log([...prev, newItem], "------------selected");
              return [...prev, newItem];
            });
          }
        } else {
          console.log("Product not found for:", productValue);
          Modal.info({
            icon: null,
            okButtonProps: { style: { display: "none" } },
            okText: "Go Back",
            content: (
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "500",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingLeft: 0,
                  fontSize: "1vw",
                }}
              >
                <img src={NotFoundImg} alt="Not Found" style={{ width: "120px", height: "100px", marginBottom: "5px", marginTop: "10px" }} />
                <p style={{ margin: "5px 0", fontSize: "2em", fontWeight: "600", color: "#0F0718" }}>Product Not Found</p>
                <hr style={{ width: "70%", color: "rgba(146,144,152,0.5" }} />
                <p style={{ color: "#0F0718", fontWeight: 400, fontSize: "1.25em", padding: "15px 15px 0 15px" }}>
                  The scanned QR code ({productValue}) is not in the system. Please check the QR code or enter the item manually.
                </p>
              </div>
            ),
            style: {
              textAlign: "center",
              height: "50vh",
              width: "50%",
            },
            bodyStyle: {
              padding: "0",
            },
            closable: false,
            onOk: null,
          });

          setTimeout(() => {
            Modal.destroyAll();
          }, 1500);
        }
      });
  };

  const barcodeScanFromConfig = async (data) => {
    try {
      console.log("Processing QR code:", data);
      let productsToProcess = [data]; // Default to single barcode/QR code
      const posConfig = tillData?.posScanConfigs?.filter((item) => item.formula !== null && item.scanTrxType === "PR");

      // Split data if a delimiter is configured
      if (posConfig?.length > 0) {
        const posConfigItem = posConfig.filter((item) => data.startsWith(item.startsWith));
        if (posConfigItem?.length > 0) {
          console.log("Using posScanConfig:", posConfigItem[0]);
          const config = posConfigItem[0];
          if (config.delimiter) {
            productsToProcess = data
              .split(config.delimiter)
              .filter(Boolean)
              .map((p) => p.trim());
            console.log("Split QR code into products:", productsToProcess);
          }
        } else {
          console.log("No matching posScanConfig found for QR code:", data);
        }
      } else {
        console.log("No posScanConfigs available");
      }

      // Process all products sequentially
      for (const productData of productsToProcess) {
        console.log("Processing product:", productData);
        const processSingleProduct = async (config, productData) => {
          let formula = JSON.parse(config.formula);
          formula.calculateTax = config.calculateTax || "N";
          await getProduct(formula, productData, tillData, config);
        };

        let productsToProcessConfig = [];
        if (posConfig?.length === 1) {
          productsToProcessConfig.push({ config: posConfig[0], data: productData });
        } else {
          let posConfigItem = posConfig?.filter((item) => productData.startsWith(item.startsWith));
          if (posConfigItem.length > 0) {
            productsToProcessConfig.push({ config: posConfigItem[0], data: productData });
          }
        }

        if (productsToProcessConfig.length > 0) {
          for (const { config, data } of productsToProcessConfig) {
            await processSingleProduct(config, data);
          }
        } else {
          console.log("No config found, using raw data for product search:", productData);
          await getProduct({ property: { "product.value": { position: 1, length: productData.length } } }, productData, tillData, {});
        }
      }
      console.log("All products processed successfully.");
    } catch (error) {
      localStorage.removeItem("productSegment");
      console.error("Error processing QR code:", error, "Data:", data);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      dataString = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Empty dependency array is fine here since tillData is static

  return null;
};

export default BarCodeHandler;
